import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Button } from '@material-ui/core';

import Liff from '@/client/utils/liff';
import { EntryDialog } from './dialog';

const Main = ({ config }) => {
  const { id, entrySvg, name } = config;

  const history = useHistory();
  const [dialogOpen, setDialogOpen] = useState(true);

  const handleStart = async () => {
    history.push(`/disease-quiz-${id}/quiz?liffId=${Liff.id}`);
  };

  return (
    <Box>
      <Button fullWidth onClick={handleStart} style={{ padding: 0 }}>
        <img src={entrySvg} alt={`${name}活動首頁`} style={{ width: '100%' }} />
      </Button>
      <EntryDialog
        open={dialogOpen}
        config={config}
        onClick={() => {
          setDialogOpen(false);
        }}
      />
    </Box>
  );
};

export default Main;
